import React, { useContext, useEffect } from "react";
import HeaderComponent from "../../../components/header/header.component";
import { CasesProvider, GlobalContext } from "../../../store";
import { CommonService } from "../../../services/common/common.service";
import { useTranslation } from "react-i18next";
import AIUseCasesContentComponent from "../../../modules/case/components/list/ai-usecases-content/ai-usecases-content.component";

const AIUseCasesPage = () => {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.AI_USE_CASES_SOFTWARE"));
      setPageTitle(t("PAGE_META_TITLES.AI_USE_CASES_SOFTWARE"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CasesProvider>
      <HeaderComponent />
      <AIUseCasesContentComponent />
    </CasesProvider>
  );
};

export default AIUseCasesPage;
